import { AnyAction } from 'redux';
import { IAppState } from '../types/state.d';
import {
  appActionTypes,
  apiActionTypes,
} from '../actions/actionCreators/actionTypes';

type State = IAppState['app'];

export const frpId = (
  state: State['frpId'] = null,
  action: AnyAction,
): State['frpId'] => {
  switch (action.type) {
    case appActionTypes.SAVE_FRP_ID:
      return action.frpId;
    default:
      return state;
  }
};

export const getInlineAlertInitialState = () => ({
  eventSearch: false,
});

export const inlineAlert = (
  state: State['inlineAlert'] = getInlineAlertInitialState(),
  action: AnyAction,
): State['inlineAlert'] => {
  switch (action.type) {
    case appActionTypes.SHOW_INLINE_ALERT:
      return {
        ...state,
        [action.inlineAlert.requestName]: true,
      };
    case appActionTypes.CLOSE_INLINE_ALERT:
      return {
        ...state,
        [action.inlineAlert.requestName]: false,
      };
    default:
      return state;
  }
};

export const selectedEvent = (
  state: State['selectedEvent'] = null,
  action: AnyAction,
): State['selectedEvent'] => {
  switch (action.type) {
    case appActionTypes.SAVE_EVENT:
    case apiActionTypes.CREATE_EVENT_REQUEST_SUCCESS:
      return action.event;
    default:
      return state;
  }
};

export const selectedCause = (
  state: State['selectedCause'] = null,
  action: AnyAction,
): State['selectedCause'] => {
  switch (action.type) {
    case appActionTypes.SAVE_CAUSE:
      return action.cause;
    case apiActionTypes.GET_CHARITY_DATA_REQUEST_SUCCESS:
      if (state) {
        return {
          ...state,
          countryCode: action.data.countryCode,
        };
      }
      return state;
    default:
      return state;
  }
};

export const selectedFundraisingPage = (
  state: State['selectedFundraisingPage'] = null,
  action: AnyAction,
): State['selectedFundraisingPage'] => {
  switch (action.type) {
    case appActionTypes.SELECT_FUNDRAISING_PAGE:
      return action.frpId;
    default:
      return state;
  }
};

export const newFrpData = (
  state: State['newFrpData'] = {
    shortName: '',
    fundraisingTarget: '',
    gdprOptIn: undefined,
  },
  action: AnyAction,
): State['newFrpData'] => {
  switch (action.type) {
    case appActionTypes.SAVE_NEW_FRP_DATA:
      return action.data;
    default:
      return state;
  }
};
